(function(){
    'use strict';
    angular.module('app').controller('JobsDetailsController', JobsDetailsController);

    JobsDetailsController.$inject = [
        '$rootScope',
        'FleetService',
        '$routeParams',
        'JobDetailsMapService',
        'PackagesTableService',
        'HistoricalChatsTableService',
        '$location',
        'toastr',
        'CommonService',
        'Shipments',
        'Units',
        '$route',
        '$timeout',
        'TrackingEventsService',
        '$window',
        'ConfirmationModalFactory',
        'WarningModalFactory',
        '$uibModal'
    ];

    function JobsDetailsController(
        $rootScope,
        FleetService,
        $routeParams,
        JobDetailsMapService,
        PackagesTableService,
        HistoricalChatsTableService,
        $location,
        toastr,
        CommonService,
        Shipments,
        Units,
        $route,
        $timeout,
        TrackingEventsService,
        $window,
        ConfirmationModalFactory,
        WarningModalFactory,
        $uibModal
    ) {
        let vm = this;
        vm.id = $routeParams.id;
        vm.isViewMode = false;
        vm.packageNotifications = [];
        vm.isArchived = $routeParams.archived;
        vm.hideButton = false;

        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.archive.MESSAGE',
            code: 'messages.warning.archive.CODE',
        });
        const warningModalFactory = new WarningModalFactory({}, {
            message: 'messages.warning.podWarning.MESSAGE',
            code: 'messages.warning.podWarning.CODE'
        });

        vm.label = {
            loaded: 'Loaded',
            notloaded: 'Not loaded',
            scanned: 'Scanned',
            missing: 'Missing',
            default: 'Not scanned'
        };
        vm.totalPackages = 0;

        const {routeId, areaId} = $routeParams;
        const urls = {
            routeId: '/areas/routes/details/' + routeId,
            areaId: '/areas/details/' + areaId
        };
        const notificationMessages = {
            loaded: 'package(s) loaded.',
            notloaded: 'package(s) not yet loaded.',
            scanned: 'package(s) scanned.',
            missing: 'package(s) missing.',
            default: 'package(s) not yet scanned.'
        };
        const notifClass = {
            loaded: 'alert-success',
            notloaded: 'alert-warning',
            scanned: 'alert-success',
            missing: 'alert-danger',
            default: 'alert-warning'
        };

        vm.printLabels = printLabels;
        vm.back = back;
        vm.update = update;
        vm.moToArchives = moToArchives;
        vm.getBatchViewFormat = getBatchViewFormat;
        vm.searchBatch = searchBatch;
        vm.printPOD = printPOD;
        vm.clearPodPhoto = clearPodPhoto;
        vm.clearSignaturePhoto = clearSignaturePhoto;
        vm.showPOD = showPOD;
        vm.downloadDocuments = downloadDocuments;

        init();

        function init(){
            FleetService.Jobs.getJobDetails(vm.id, data=>{
                vm.job = data;
                if(!vm.job.batch) {
                    vm.job.batch = {batchId: 0};
                }

                vm.mapData = new JobDetailsMapService(data).mapData;
                vm.packagesData = new PackagesTableService(data.packages).tableData;
                vm.historicalChatsData = new HistoricalChatsTableService({jobId: vm.id}).tableData;
                vm.hideButton = hideButton()
                initPackageNotifications(data.packages);
                reOrderLinkJobs();
                getTrackingEvents();
                getDeliveryGeoLocation();
            }, error=>{
                toastr.error('Unable to get job', error.message);
            });
        }

        function getDeliveryGeoLocation() {
            const lng = angular.getObjVal(vm.job, 'destinationAddress.actualLongitude') || 0;
            const lat = angular.getObjVal(vm.job, 'destinationAddress.actualLatitude') || 0;
            vm.deliveryGeoLocation = {lat, lng};
        }

        function getTrackingEvents(){
            FleetService.Jobs.jobTracking(vm.job.id, tracking => {
                vm.trackingEventsData = new TrackingEventsService('', tracking).data;
            }, error => {
                console.log(error);
            });
        }

        function reOrderLinkJobs(){
            let batch = vm.job.linkedJobs.filter(data => data.jobId.includes('BATCH'));
            let jobs  = vm.job.linkedJobs.filter(data => data.jobId.includes('JOBS'));
            let jfm   = vm.job.linkedJobs.filter(data => data.jobId.includes('JFM'));
            let jlh   = vm.job.linkedJobs.filter(data => data.jobId.includes('JLH'));
            let jlm   = vm.job.linkedJobs.filter(data => data.jobId.includes('JLM'));
            vm.job.linkedJobs = batch.concat(jobs).concat(jfm).concat(jlh).concat(jlm);
        }

        function initPackageNotifications(packages) {
            packages.forEach(pack=>{
               //count total packages
               vm.totalPackages += (pack.quantity || 0);
               const packIndex = vm.packageNotifications.findIndex(notif=>(pack.packageStatus || 'default')===notif.type);
               if(packIndex >= 0){
                   vm.packageNotifications[packIndex].count++;
                   return false;
               }
               vm.packageNotifications.push({
                   count: 1,
                   message: notificationMessages[pack.packageStatus] || notificationMessages['default'],
                   type: pack.packageStatus || 'default',
                   class: notifClass[pack.packageStatus] || notifClass['default'],
               })
            });
        }

        function getBatchViewFormat(item) {
            if(!item || item.batchId === 0){
                return `N/A (AD HOC Job)`;
            }
            const batch = item || {};
            const weightUnit = Units.getWeightUnit($rootScope.GlobalProfile.office.weightUnit);
            const totalPackagesCubicWeightFormatted = `(${batch.totalPackagesCubicWeight} ${weightUnit})`;
            return `${batch.batchId} (${batch.totalJobsNumber} Jobs) ${totalPackagesCubicWeightFormatted}`;
        }

        function searchBatch(select) {
            if(!select.open){
                return false;
            }
            vm.dropdownFetching = true;
            FleetService.Jobs.getAllJobBatches(data=>{
                vm.batches = [{batchId: 0}, ...data.content];
                vm.dropdownFetching = false;
            }, err=>{
                toastr.error('Unable to get batches', err.message);
                vm.dropdownFetching = false;
            }, {
                size: 20,
                batchId: select.search
            })
        }

        function printLabels(job) {
            Shipments.getShipmentDetails(job.shipmentId, data => {
                if(data.consignmentId){
                    CommonService.printDocuments(data);
                }
            }, err=>{
                toastr.error('Unable to print labels')
            });
        }

        function hideButton(){
            if(vm.isArchived){
                return false
            }
            if(vm.job.jobStatus != 'delivered' && !vm.isViewMode){
                return true
            }
        }

        function update(job) {    
            if (!isPhotoUploadValid()) {
                warningModalFactory.getInstance();
                return;
            }

            vm.isLoading = true;
            FleetService.Jobs.update(vm.id, cleanPayload(job), data=>{
                if(vm.upodPhoto && vm.signaturePhoto) {
                    const frmData= new FormData();
                    // frmData.append('pod[]', vm.upodPhoto);
                    frmData.append('signature', vm.signaturePhoto);

                    // POD photos (multiple)
                    if (vm.upodPhoto && vm.upodPhoto.length) {
                        angular.forEach(vm.upodPhoto, function (file) {
                            frmData.append('pod[]', file);
                        });
                    }

                    
                    const payload = {
                        query: {
                            jobId: vm.id,
                            resellerId: $rootScope.GlobalProfile.company.id,
                            name: `pod=${vm.id}`,
                            remarks: 'uploaded manually'
                        },
                        frmData: frmData
                    };

                    FleetService.Jobs.uploadPod(payload, success => {
                        toastr.success('Job successfully updated!');
                        $route.reload();
                        vm.isLoading = false;
                    }, error => {
                        toastr.error(error.message, 'Error');
                        vm.isLoading = false;
                    });
                } else {
                    toastr.success('Job successfully updated!');
                    $route.reload();
                }
            }, err=>{
                vm.isLoading = false;
                toastr.error('Unable to update job', err.message);
            });
        }

        function isPhotoUploadValid() {
            if (vm.upodPhoto && !vm.signaturePhoto) {
                return false;
            }

            if(vm.signaturePhoto && !vm.upodPhoto) {
                return false;
            }

            return true;
        }

        function clearPodPhoto() {
            vm.upodPhoto = null;
        }

        function clearSignaturePhoto() {
            vm.signaturePhoto = null;
        }

        function moToArchives(job){
            viewConfirmation.getInstance().result.then(function (cond) {
                if(cond){
                    FleetService.Jobs.moveToArchives([job.id],
                        res=>{
                            toastr.success('Successfully move to archives.');
                            back();
                        },
                        err=>{
                            toastr.error(err.message,err.code);
                    })
                }
            });
        }

        function back(){
            $window.history.back();
        }

        function cleanPayload(job) {
            let {
                carrierProfile,
                companyId,
                consignmentId,
                deliveryDetails,
                destinationAddress,
                driver,
                jobFinancials,
                jobId,
                jobLinks,
                jobStatus,
                packages,
                pickupWindow,
                remarks,
                sourceAddress,
                type,
                signatureUrl,
                unattendedPhotoUrl,
                batch
            } = job;
            return {
                carrierProfileId: carrierProfile.id,
                companyId: companyId,
                consignmentId: consignmentId,
                deliveryDetails: deliveryDetails,
                destinationAddress: destinationAddress,
                driverId: angular.getObjVal(driver, 'id'),
                jobFinancials: jobFinancials,
                jobId: jobId,
                jobLinks: jobLinks,
                jobStatus: jobStatus.value,
                packages: packages,
                pickupWindow: pickupWindow,
                remarks: remarks,
                signatureUrl: signatureUrl,
                sourceAddress: sourceAddress,
                type: type,
                unattendedPhotoUrl: unattendedPhotoUrl,
                batchId:  angular.getObjVal(batch, 'id') || job.batchId || 0
            }
        }

        function downloadDocuments(){
            Shipments.requestShipmentDocs(vm.job.shipmentId,
                res=>{
                    toastr.success('Documents Downloaded', 'Success');
                },
                err=>{
                    toastr.error('No Documents uploaded', 'Error');
                });
        }

        function printPOD(){
            vm.downloadingPOD = true;
            Shipments.downloadPOD(vm.job.shipmentId, success => {
                vm.downloadingPOD = false;
                toastr.success("POD Downloaded", "Success");
            }, error => {
                vm.downloadingPOD = false;
                if(error.code == 404) {
                    toastr.warning("No POD found for this job.", "Warning");
                } 
                else {
                    toastr.error(error.message, error);
                }
            });
        }

        function showPOD(imgSrc, label) {
            const modalInstance = $uibModal.open({
                animation: true, 
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: 'setting-modal',   
                templateUrl: '/templates/pages/jobs/proff-delivery-modal.html',
                controller: 'ProffOfDeliveryModalController',
                controllerAs: 'vm',
                size: 'lg',
                appendTo: $('body'),
                resolve: {
                    imageSrc: () => { return imgSrc; },
                    label: () => { return label; }
                }
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/jobs/JobsDetailsController.js